import React from "react";
import Button from "./Button";
import homestyle from "../styles/css/content/homecontent.module.css";
import ContentHome from "../content-parts/ContentHome";
import LoadPageContent from "../frontenddata/LoadPageContent";
import LoadImageContent from "../frontenddata/LoadImageContent";
import LoadJobsContent from "../frontenddata/LoadJobsContent";
import LoadImageTeaserContent from "../frontenddata/LoadImageTeaserContent";
import VideoPlayer from "../content-parts/VideoPlayer";
import feapiurl from "../feapiurl";
import axios from "axios";

function HomeContent(){
const [hasVideo, setHasVideo] = React.useState(false);
const [VideoContent, setVideoContent] =  React.useState([]);
const [videoPoster, setVideoPoster] = React.useState("");

React.useEffect(()=>{

   document.body.className = "home";

})


    const fetchurl =feapiurl+ "getvideocontent.php";
const pageid = 4;
    React.useEffect(() => {
        const getData = async () => {
            try {
                const response = await axios.post(fetchurl, {pageid});
                const result = response.data;

                if(result.length > 0) {

                    setVideoContent(result[0]);
                    setHasVideo(true);
                }
                else{
                    setHasVideo(false);
                }
            }

            catch (error) {
                console.error('Fehler', error);
            }
        };

        getData();
    }, [VideoContent]);


    return(
    <section className={homestyle.pagehome}>
    <section className={homestyle.homecontent}>
<LoadPageContent pageid="4" hasFlexRow={false} />

    </section>
        {
            hasVideo ?(<VideoPlayer videocontent={VideoContent} postercontent />):(<LoadImageTeaserContent pageid="4"/>)

        }
        <LoadJobsContent hasFlexRow={true}/>
       <LoadImageContent pageid="4" mediaType="slider"/>

        <LoadPageContent pageid="1" hasFlexRow={true} backGroundColor="var(--content-uns-background)" marginhorizontal="0px" contentClass="ueberuns"/>

        <LoadImageContent pageid="1" mediaType={"gallery"} marginBottom="0px" className={"ueberunsgallery"}/>


    </section>
    )

}
export default HomeContent;
